import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Check } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function WhatYouGet() {
  const features = ['+500 recetas', 'técnicas de barista', 'métodos de preparación', 'cultura cafetera'];
  return <section className="py-10 md:py-14 px-4" data-id="element-203">
      <div className="max-w-5xl mx-auto" data-id="element-204">
        <div className="text-center mb-10" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-bold text-espresso-900 mb-3" data-id="element-206">
            DESCARGA HOY Y RECIBE{' '}
            <u className="decoration-gold-500 decoration-2 underline-offset-4" data-id="element-207">
              CON TU COMPRA
            </u>
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-208"></div>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-espresso-900/10" data-id="element-209">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-210">
            {/* Image Side */}
            <div className="bg-cream-200 p-6 md:p-8 flex items-center justify-center relative overflow-hidden" data-id="element-211">
              <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-espresso-900 to-transparent" data-id="element-212"></div>
              <motion.div whileHover={{
              scale: 1.02,
              rotate: -2
            }} className="relative w-full max-w-xs flex flex-col items-center" data-id="element-213">
                <img src="https://cdn.magicpatterns.com/uploads/hYo6CP8csFeSZDfSppn3bL/20260312_1033_Image_Generation_remix_01kkh3yer1f6vbc3zvvk8zjamn.png" alt="El Arte del Café - Libro Digital" className="w-full rounded-2xl shadow-2xl object-cover" data-id="element-214" />
                <h3 className="font-serif text-xl font-bold text-espresso-900 mt-3 text-center" data-id="element-215">
                  El Arte del Café
                </h3>
              </motion.div>
            </div>

            {/* Content Side */}
            <div className="p-6 md:p-8 flex flex-col justify-center" data-id="element-216">
              <h3 className="text-2xl md:text-3xl font-bold text-espresso-900 mb-3" data-id="element-217">
                La guía <em data-id="element-218">definitiva</em> para preparar{' '}
                <strong data-id="element-219">café profesional en casa.</strong>
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-220">
                {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3 bg-cream-100 p-2.5 rounded-lg border border-espresso-900/5" data-id="element-221">
                    <Check className="w-5 h-5 text-cta-600" data-id="element-222" />
                    <span className="font-medium text-espresso-800" data-id="element-223">
                      {feature}
                    </span>
                  </div>)}
              </div>

              <div className="bg-cream-100 p-4 rounded-xl border border-gold-500/30 text-center mb-6" data-id="element-224">
                <p className="text-sm font-bold text-espresso-700 uppercase tracking-wider mb-1" data-id="element-225">
                  Oferta Especial
                </p>
                <div className="flex justify-center" data-id="element-226">
                  <PriceDisplay amount={13.97} originalAmount={30} size="lg" data-id="element-227" />
                </div>
              </div>

              <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" className="w-full bg-cta-600 hover:bg-cta-800 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all text-center flex items-center justify-center gap-2" data-id="element-228">
                <span className="text-2xl" data-id="element-229"></span> Agregar al carrito
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}